import { parsePhoneNumberFromString } from "libphonenumber-js";

/** US default region matches createOrUpdateLead. E.164 via libphonenumber-js. */
export function normalizeCheckoutPhone(
  phone: unknown
): { ok: true; e164?: string } | { ok: false } {
  if (phone == null || typeof phone !== "string") return { ok: true };
  const trimmed = phone.trim();
  if (!trimmed) return { ok: true };
  try {
    const parsed = parsePhoneNumberFromString(trimmed, "US");
    if (parsed?.isValid()) return { ok: true, e164: parsed.number };
  } catch (err) {
    console.error(`Error parsing checkout phone ${trimmed}:`, err);
  }
  return { ok: false };
}
